// @ts-strict-ignore

import type { CurationTool } from '@empathybroker/tsclient-play/dist/models/curation-tools/curation-tool'
import type { CurationToolRule } from '@empathybroker/tsclient-play/dist/models/curation-tools/curation-tool-rule'
import type { DataTableColumn, RegularFilterConfig } from '../models'

import { CurationToolRuleTypeEnum } from '@empathybroker/tsclient-play/dist/enums/curation-tool-rule-type.enum'

import { CrudListMixin } from '../mixins/crud-list.mixin'

export const CurationToolListMixin = {
  mixins: [CrudListMixin],
  computed: {
    listProps(): Record<string, any> {
      return {
        readOnly: this.readOnly,
        query: this.context.query,
        selection: this.selection,
        searchBoxAvailable: false,
        enableActionsAvailable: false,
        pagination: this.pagination,
        itemsPerPageOptions: this.itemsPerPageOptions,
        messages: this.messages,
      }
    },
    listHooks(): Record<string, () => void> {
      return {
        queryChange: this.onQueryChange,
        selectionChange: this.onSelectionChange,
        create: () => this.navigateToRoute(this.routes.create),
        clone: () => this.navigateToRoute(this.routes.create),
        update: () => this.navigateToRoute(this.routes.update),
        setEnabled: this.setEnabled,
        delete: this.onDelete,
        paginationChange: this.onPaginationChange,
      }
    },
    tableProps(): Record<string, any> {
      return {
        columns: this.tableColumns,
        data: this.tableData,
        sort: this.sort,
        select: { enabled: !this.readOnly, multiple: true },
        selection: this.selection,
        loading: this.loadingData,
      }
    },
    tableColumns(): DataTableColumn[] {
      const pivotColumns = this.pivotsColumns.map((column: DataTableColumn) => ({
        ...column,
        sortable: false,
      }))
      const fieldMessages = this.messages.fields
      const ruleColumns = Object.values(CurationToolRuleTypeEnum).map(
        (type: CurationToolRuleTypeEnum) => ({
          id: type,
          text: fieldMessages.rules.types[type],
        }),
      )
      return [
        ...pivotColumns,
        ...ruleColumns,
        {
          id: 'meta.updateDate',
          text: fieldMessages.updateDate.label,
        },
        {
          id: 'meta.user',
          text: fieldMessages.user.label,
        },
      ]
    },
    tableData(): Record<string, any>[] {
      return this.data.map((dataItem: CurationTool) => {
        const pivotsData = this.visiblePivotsConfig.reduce(
          (data: Record<string, string>, pivotConfig: RegularFilterConfig) => ({
            ...data,
            [this.getPivotColumnId(pivotConfig)]: this.getPivotText(pivotConfig, dataItem),
          }),
          {},
        )
        const rulesData = Object.values(CurationToolRuleTypeEnum).reduce(
          (data: Record<string, string>, type: CurationToolRuleTypeEnum) => ({
            ...data,
            [type]: this.getRulesByType(dataItem.rules, type).map(this.getRuleText),
          }),
          {},
        )
        return {
          ...dataItem,
          ...pivotsData,
          ...rulesData,
        }
      })
    },
    tableHooks(): Record<string, () => void> {
      return {
        sortChange: this.onSortChange,
        selectionChange: this.onSelectionChange,
      }
    },
  },
  methods: {
    getRulesByType(rules: CurationToolRule[], type: CurationToolRuleTypeEnum): CurationToolRule[] {
      return rules.filter((rule: CurationToolRule) => rule.type === type)
    },
    getRuleText(rule: CurationToolRule): string {
      return rule.id
    },
  },
}
